import React from "react";
import { useTranslation } from "react-i18next";
import AlarmIcon from "@mui/icons-material/Alarm";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import useCacheDataMainTask from "hooks/useCacheDataMainTask";

const Appointment = (props) => {
  const { t } = useTranslation();
  const totalRemind = useCacheDataMainTask(
    "taskDetail.detailTask.taskDetails.total_remind",
    0
  );
  const totalLocation = useCacheDataMainTask(
    "taskDetail.detailTask.taskDetails.total_location",
    0
  );

  return (
    <div className="listPartTabBody--appointments">
      <div
        className="listPartTabBody--menuItem-btn"
        onClick={() => props.setShow(3)}
      >
        <AlarmIcon /> {t("LABEL_CHAT_TASK_DANH_SACH_NHAC_HEN")} ({totalRemind})
      </div>
      <div
        className="listPartTabBody--menuItem-btn"
        onClick={() => props.setShow(5)}
      >
        <PlaceOutlinedIcon /> {t("LABEL_CHAT_TASK_DANH_SACH_VI_TRI_CHIA_SE")} (
        {totalLocation})
      </div>
    </div>
  );
};

export default Appointment;
